<div class="cc-wrap">
  <h3 class="cc-heading">Try It Yourself</h3>

  <div class="color-converter">
    <div class="cc-head">
      <!-- The swatch itself is the colour picker: click it to open the native
           picker. It shows the current colour and replaces the old separate box. -->
      <input class="cc-swatch"
             type="color"
             [value]="swatch"
             (input)="onPicker($any($event.target).value)"
             aria-label="Pick a color">
      <div class="cc-input-wrap">
        <label class="cc-label" for="cc-hex">Pick a Color</label>
        <input id="cc-hex"
               class="cc-text"
               type="text"
               autocomplete="off"
               spellcheck="false"
               maxlength="7"
               inputmode="latin"
               [value]="text"
               (input)="onText($any($event.target).value)"
               (keydown)="onKey($event)"
               aria-label="Hex color code">
      </div>
    </div>

    <!-- Two halves: the RGB value with its channel bars, and the CMYK value with
         its channel bars, each a weighted bar like the /tools/color page. -->
    <div class="cc-groups">
      <div class="cc-channels cc-group">
        <div class="cc-channel" *ngFor="let ch of rgbChannels">
          <span class="cc-channel-label">{{ ch.label }}</span>
          <span class="cc-channel-track">
            <span class="cc-channel-fill" [style.width.%]="ch.pct" [style.background]="ch.color"></span>
          </span>
          <span class="cc-channel-val">{{ ch.text }}</span>
        </div>
      </div>

      <div class="cc-channels cc-group">
        <div class="cc-channel" *ngFor="let ch of cmykChannels">
          <span class="cc-channel-label">{{ ch.label }}</span>
          <span class="cc-channel-track">
            <span class="cc-channel-fill" [style.width.%]="ch.pct" [style.background]="ch.color"></span>
          </span>
          <span class="cc-channel-val">{{ ch.text }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
